import clsx from "clsx";
import { TimelineInterface } from "../types/chase-timeline-types";
import moment from "moment";
import { useState } from "react";
import chaseTimeLineData from "../utils/data/chase-timeline-data";

const ProgressBar = ({ timeline }: { timeline?: TimelineInterface[] }) => {
  const [hovered, setHovered] = useState<number | null>(null);
  const currentStep = timeline
    .sort((a, b) => b?.day - a?.day)
    .find((timelineStep) => timelineStep?.done !== false);
  const currentSetpData = chaseTimeLineData?.find(
    (chasetimlineDat) => chasetimlineDat?.day === currentStep?.day
  );
  timeline = timeline.sort((a, b) => a?.day - b?.day);

  const onMouseOver = (day: number) => {
    setHovered(day);
  };

  const onMouseDown = () => {
    setHovered(null);
  };

  return (
    <div className="w-full h-2 rounded-full bg-overlay-mid border border-edge flex items-center justify-between relative shadow-inner">
      {/* --------------------------- INDICATOR LINE ------------------- */}

      <div
        className={
          "absolute left-0 top-[50%] translate-y-[-50%] h-1 bg-gradient-to-r from-accent to-blue max-w-[100%] rounded-full transition-all duration-500"
        }
        style={{
          width: `${Math.floor(
            Math.floor(100 * (currentStep?.day - 1)) / (timeline.length - 1)
          )}%`,
        }}
      ></div>
      <div
        style={{
          width: `${Math.floor(
            Math.floor(100 * 2.2) / (timeline.length - 1)
          )}%`,
        }}
        className="w-full h-full bg-amber-500/20 absolute right-0 rounded-full"
      ></div>

      {/* --------------------------- INDICATOR LINE ------------------- */}
      {timeline.map((item, index) => {
        let timeLineDate = new Date(item?.startDate);
        timeLineDate.setDate(timeLineDate.getDate() + index);
        const isCurrentStep = currentSetpData;
        const showLable =
          (index === 0 ||
            index === timeline.length - 1 ||
            item?.day === isCurrentStep?.day) &&
          !hovered;
        let ishoveredDay = chaseTimeLineData.find(
          (chasetimedata) => chasetimedata.day === item.day
        );

        return (
          <div
            key={index}
            className={clsx(
              "h-[14px] w-[14px] bg-surface-elevated border border-edge-strong rounded-full flex items-center justify-center cursor-pointer relative transition-transform duration-200 hover:scale-110",
              index + 1 === currentStep?.day && "!h-[20px] !w-[20px]"
            )}
          >
            <div
              className={clsx(
                "relative w-[80%] h-[80%] rounded-full bg-overlay-mid",
                index + 1 <= currentStep?.day && "!bg-gradient-to-br !from-accent !to-blue",
                index + 1 >= 29 && "!bg-amber-400"
              )}
              onMouseEnter={() => onMouseOver(item?.day)}
              onMouseLeave={onMouseDown}
            ></div>

            {/* ---------------------------- LABEL ------------------------------- */}
            {(showLable || (hovered === item?.day && ishoveredDay)) && (
              <div
                className={clsx(
                  "absolute top-[120%] left-[50%] translate-x-[-50%] text-center rounded-lg bg-surface-elevated border border-edge px-2 py-1 shadow-card",
                  hovered === item?.day ? "z-20" : "z-10",
                  index === 0 && "!left-[-1px] !translate-x-0 !text-start",
                  index === timeline.length - 1 &&
                    "!left-[100%] !translate-x-[-100%] text-right"
                )}
              >
                <h3
                  className={clsx(
                    "text-[.8rem] font-medium text-heading-color m-0 p-0 !text-nowrap",
                    (item?.day === 1 || item?.day === timeline.length) &&
                      "!font-medium !text-wrap"
                  )}
                >{`Day ${item?.day}`}</h3>
                {showLable && (
                  <p className="text-[.7rem] text-light-gray font-semibold !text-nowrap">
                    {moment(timeLineDate).format("DD-MM-YYYY")}
                  </p>
                )}
              </div>
            )}
            {/* ---------------------------- LABEL ------------------------------- */}
          </div>
        );
      })}
    </div>
  );
};

export default ProgressBar;
